"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleButtonGroup = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _ButtonGroup = require("../ButtonGroup/ButtonGroup");
var _excluded = ["children", "defaultValue", "onChange", "value"];
/**
 * @extends ButtonGroup
 * @since 8.0.0
 */
var ToggleButtonGroup = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var children = _ref.children,
    defaultValue = _ref.defaultValue,
    onChange = _ref.onChange,
    value = _ref.value,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var _useState = (0, _react.useState)(defaultValue),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    valueState = _useState2[0],
    setValueState = _useState2[1];
  var controlled = typeof value !== 'undefined';
  var pressedValue = controlled ? value : valueState;
  var onClickCallback = (0, _react.useCallback)(function (e, pressed, onClick) {
    // Get the next expected value
    var nextValue = pressedValue;
    if (!pressed) {
      nextValue = e.currentTarget.value;
    }

    // Only update if values differ
    if (nextValue !== pressedValue) {
      setValueState(nextValue);
      if (onChange) {
        onChange(nextValue);
      }
    }

    // Handles consumer provided `onClick`
    if (onClick) {
      onClick(e, e.currentTarget.value === nextValue);
    }
  }, [pressedValue, onChange]);
  var cloneChild = (0, _react.useCallback)(function (child) {
    if (!child) {
      return null;
    }
    return /*#__PURE__*/(0, _react.cloneElement)(child, {
      pressed: child.props.value === pressedValue,
      onClick: function onClick() {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        onClickCallback.apply(void 0, args.concat([child.props.onClick]));
      }
    });
  }, [onClickCallback, pressedValue]);
  return /*#__PURE__*/_react.default.createElement(_ButtonGroup.ButtonGroup, (0, _extends2.default)({
    ref: forwardedRef
  }, rest), _react.Children.map(children, cloneChild));
});
exports.ToggleButtonGroup = ToggleButtonGroup;
ToggleButtonGroup.displayName = 'ToggleButtonGroup';
ToggleButtonGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A group of `ToggleButton` components.
   */
  children: _propTypes.default.node.isRequired,
  /**
   * The `ButtonGroup` `conjoined`
   * prop, set to `true` by default for toggle button groups.
   */
  conjoined: _propTypes.default.bool,
  /**
   * Set the toggle button group value, and use as an
   * [uncontrolled component](https://reactjs.org/docs/uncontrolled-components.html).
   *
   * A toggle button group can set `value` or `defaultValue`, but not both.
   */
  defaultValue: _propTypes.default.string,
  /**
   * Callback for change events within the toggle button group. The callback will receive the
   * `value` of the currently selected `ToggleButton`, or `undefined` if all
   * buttons are unpressed.
   */
  onChange: _propTypes.default.func,
  /**
   * Set the toggle button group value, and use as an
   * [controlled component](https://reactjs.org/docs/forms.html#controlled-components).
   *
   * A toggle button group can set `value` or `defaultValue`, but not both.
   */
  value: _propTypes.default.string
} : {};
ToggleButtonGroup.defaultProps = {
  conjoined: true,
  defaultValue: undefined,
  onChange: undefined,
  value: undefined
};